import { render } from "./AdminLayout.vue?vue&type=template&id=f64d5bfe&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=f64d5bfe&lang=scss"
import "./AdminLayout.vue?vue&type=style&index=1&id=f64d5bfe&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\bfern\\Documents\\la-vuelta-trama\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64d5bfe"]])

export default __exports__